
import sdCard from '@smartdesign/vue/components/card';

export default {
  name: 'AppStep',
  components: {
    sdCard,
  },
  props: {
    number: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    list: {
      type: Array,
      default: undefined,
      required: false,
    },
  },
};
